import http from "../utils/http";
//https://traduora-pro.aenduocloudservices.com/ae-Linde/exports?locale=it&format=jsonnested
export const getLanguageTraduora = (lang: string, projectId: string) => http.get(`https://traduora-pro.aenduocloudservices.com/ae-${projectId}/exports?locale=${lang}&format=jsonnested`)
